import {useMemo} from 'react'
import {PayPeriodData} from '../../../../models/enhancement/pay-period-data'

interface UsePayPeriodModalProps {
  payPeriodsByYear: Record<number, PayPeriodData[]>;
  availableYears: number[];
  selectedYear: number;
  onYearChange: (year: number) => void;
}

export interface UsePayPeriodModalReturn {
  selectedYear: number;
  periodsForYear: PayPeriodData[];
  canNavigateToPreviousYear: boolean;
  canNavigateToNextYear: boolean;
  navigateToPreviousYear: () => void;
  navigateToNextYear: () => void;
}

export function usePayPeriodModal({
                                    payPeriodsByYear,
                                    availableYears,
                                    selectedYear,
                                    onYearChange
                                  }: UsePayPeriodModalProps): UsePayPeriodModalReturn {
  const periodsForYear = useMemo(() =>
    payPeriodsByYear[selectedYear] || [], [payPeriodsByYear, selectedYear])
  
  const currentYearIndex = availableYears.indexOf(selectedYear)
  
  const canNavigateToPreviousYear = currentYearIndex < availableYears.length - 1
  
  const canNavigateToNextYear = currentYearIndex > 0
  
  const navigateToPreviousYear = () => {
    if (canNavigateToPreviousYear) {
      onYearChange(availableYears[currentYearIndex + 1])
    }
  }
  
  const navigateToNextYear = () => {
    if (canNavigateToNextYear) {
      onYearChange(availableYears[currentYearIndex - 1])
    }
  }

  return {
    selectedYear,
    periodsForYear,
    canNavigateToPreviousYear,
    canNavigateToNextYear,
    navigateToPreviousYear,
    navigateToNextYear
  }
}